import React from "react";

import * as S from "./styles";

export const Adidas: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.Text>
          <p>
            Em março, a estilista{" "}
            <a
              href="https://www.stellamccartney.com/gb/en/stellas-world/the-worlds-first-mylo-garments-created-from-vegan-mushroom-leather.html"
              target="_blank"
              rel="noreferrer"
            >
              Stella McCartney
            </a>{" "}
            lançou duas peças feitas de micélio. O tecido foi utilizado na
            criação de um bustiê e uma calça utilitária, tornando-se assim a
            primeira marca de luxo a lançar um produto com base nesse
            biomaterial.
          </p>
          <p>
            No mês seguinte, foi a vez da Adidas, que utilizou o Mylo para o
            lançamento do{" "}
            <a
              href="https://news.adidas.com/originals/stan-smith-mylo--recreating-an-icon-made-with-underground-roots-of-mushrooms/s/3403a796-7db3-429c-8a3b-6378c2f962b0"
              target="_blank"
              rel="noreferrer"
            >
              Stan Smith Mylo
            </a>
            , o primeiro tênis confeccionado de micélio.
          </p>
        </S.Text>
      </S.Content>
      <S.PhotosWrapper>
        <S.Background1>
          <S.Credit>Adidas</S.Credit>
        </S.Background1>
        <S.Background2 />
      </S.PhotosWrapper>
      <S.PhotosWrapper className="mobile">
        <S.Credit>Adidas</S.Credit>
        <S.Photo1 />
        <S.Photo2 />
      </S.PhotosWrapper>
    </S.Container>
  );
};
